'use client'

import { largeHero } from '@stereoagency/sanity-schema'
import { LargeHero as UILargeHero } from '@stereoagency/ui';
import { SimpleBlockContent } from '../sanity/client';
import { actionAsProps, sanityImageAsProps } from '@/utils';

type Props = typeof largeHero.schema.largeHero

export default function LargeHero({
  actionLabel,
  action,
  title,
  description,
  primaryImage,
  secondaryImage,
}: Props) {
  if (!title || !primaryImage?.asset._ref || !secondaryImage?.asset._ref) {
    return null;
  }

  return (
    <UILargeHero
      title={title}
      description={description
        ? <SimpleBlockContent value={description} />
        : null}
      primaryImage={sanityImageAsProps(primaryImage)}
      secondaryImage={sanityImageAsProps(secondaryImage)}
      label={actionLabel}
      action={action ? actionAsProps(action) : undefined}
    />
  )
}